module.exports = __webpack_public_path__ + "img/cm.dcfa85eb.svg";